import { Component, Suspense, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useApp } from "../context";
import { Loading } from "./common";

class PageErrorBoundary extends Component<{
  children: ReactNode;
  fallback: ReactNode;
  resetKey: string;
}> {
  state = { failed: false, resetKey: this.props.resetKey };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  static getDerivedStateFromProps(
    props: { resetKey: string },
    state: { resetKey: string },
  ) {
    if (props.resetKey !== state.resetKey)
      return { failed: false, resetKey: props.resetKey };
    return null;
  }
  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}

/** Keep navigation and the account provider mounted while a page loads or fails. */
export default function RouteBoundary({ children }: { children: ReactNode }) {
  const location = useLocation(),
    { t } = useApp();
  return (
    <PageErrorBoundary
      resetKey={location.pathname + location.search}
      fallback={
        <div className="state error" role="alert">
          <p>
            {t(
              "ページを読み込めませんでした。再読み込みしてお試しください。",
              "页面未能加载，请刷新后重试。",
            )}
          </p>
          <button
            className="button outline"
            onClick={() => window.location.reload()}
          >
            {t("ページを再読み込み", "刷新页面")}
          </button>
        </div>
      }
    >
      <Suspense fallback={<Loading />}>{children}</Suspense>
    </PageErrorBoundary>
  );
}
